import { jsx as _jsx } from "react/jsx-runtime";
import { GhostBlock } from "@faire/retailer-visitor-shared/components/GhostLoading/GhostBlock";
import { POSLogo, POSLogoWithText } from "@faire/retailer-visitor-shared/features/PointOfSale/components/POSLogo";
import { useEnabledPOSTypes } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/useEnabledPOSTypes";
import { Row } from "@faire/web--source/slate/Layout";
import React from "react";
export var EnabledPOSTypes = function(param) {
    var includeText = param.includeText;
    var _useEnabledPOSTypes = useEnabledPOSTypes(), isLoading = _useEnabledPOSTypes.isLoading, enabledTypes = _useEnabledPOSTypes.types;
    if (includeText) {
        return /*#__PURE__*/ _jsx(Row, {
            gap: "3x",
            align: "center",
            children: isLoading ? /*#__PURE__*/ _jsx(GhostBlock, {
                $width: "300px",
                $height: "24px"
            }) : enabledTypes.map(function(type) {
                return /*#__PURE__*/ _jsx(POSLogoWithText, {
                    type: type
                }, type);
            })
        });
    }
    return /*#__PURE__*/ _jsx(Row, {
        gap: "2x",
        align: "center",
        children: isLoading ? /*#__PURE__*/ _jsx(GhostBlock, {
            $width: "80px",
            $height: "16px"
        }) : enabledTypes.map(function(type) {
            return /*#__PURE__*/ _jsx(POSLogo, {
                type: type,
                size: 16
            }, type);
        })
    });
};
